import { config } from '@/config'

/**
 * ライブ配信が可能かどうかを返す
 * ユートニックアプリは原則ライブ配信は非公開だが、特定のアーティストのみ、アーティストIDを以下に指定することで配信を行えるにしている
 * https://app.clickup.com/t/908127/UT-12276
 */
export const isAvailableLiveStream = (artistId: string | undefined) => {
  if (!config.modules.liveStream) return false
  if (config.applicationKey !== 'utoniq') return true
  if (!artistId) return false
  if (config.environment !== 'production') return true

  return [
    // 江藤彩也香
    'RITUzcsJXSRY3GUotrUhODJzC5k1',
    // 松岡里果
    'd7BCGfNv1PVWQJOeJHMfVv6whJ92',
    // 検証用stgアーティスト
    'G1AT0lhFhBQoE6D34CzsNShtobC2',
    // ウソツキ
    'RDSfDmG1hoXzu0p1cYRg2RNbu3o1',
  ].includes(artistId)
}
